import React, {FC} from "react"
import Validation from "@irati/utils/validation"
import Input from "@irati/ui/src/FormItem/Input"
import {Region} from "@irati/types"

interface Props {
  region: Partial<Region>,
  disabled: boolean,
  onChange: (fieldName: string, value: string) => void
}

const RegionId: FC<Props> = ({region, disabled, onChange}) => {
  return (
    <Input
      label="Region id*"
      hint="The region id must be unique and cannot change after creation. It should be human readable (e.g. UK, AU, IRE)"
      name="regionId"
      type="text"
      disabled={disabled}
      value={region.id}
      includeCharCountdown={false}
      validation={Validation.string("The region name is required.").max(20)}
      onChange={(newValue) => onChange("id", newValue)} />
  )
}

export default RegionId
